<div class="d-flex justify-content-center" (click)="selectViewOrderChange.emit(true)">
	<div class="kiosk-order-status-button" [style.background-color]="kioskService.venueService.ooStyles?.kioskOrderStatusButtonBgColor">
		<div class="d-flex">
			<div class="order-cart-contents">{{ activeOrder.seats[0].items?.length }} items in your cart</div>
			<div class="order-cart-value ms-auto">{{ activeOrder.seats[0].total | currency }}</div>
		</div>
	</div>
</div>
